<template>
  <div class="evaluatepage">
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">车主评价</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div>
    <!-- 返回 结束 -->
    <!-- 列表tab  开始 -->
    <van-tabs v-model="evaluatekind" @click="changelineIndex">
      <van-tab v-for="(item,index) in tab" :title="item.text"></van-tab>
    </van-tabs>
    <!-- 列表tab  结束 -->
    <div class="evaluatelist">
      <div class="pingjiabox" v-for="(item,index) in commentList">
        <div class="pingjiadetailtop">
          <div class="pingjiadetailleft">
            <img class="pingjiaimg" src="../../../static/morenimg.png" />
            <div>
              <div class="pingjiatel">{{item.is_anonymous==1 ? '匿名用户':  item.user.username }}</div>
              <div class="pingjiaxingbox">
                <ul class="star">
                  <li v-for="(itemClass,index) in item.starlist" :class="itemClass" class="star-item" track-by="index"></li>
                  <!--性能优化 track-by 数据不改变时不会重新渲染-->
                </ul>
              </div>
            </div>
          </div>
          <div class="pingjiatime">{{ item.created_at }}</div>
        </div>
        <div class="labellist">
          <div class="labelbox" v-for="(label,index) in item.tags">{{ label }}</div>
        </div>
        <div class="pingjiamessage">{{ item.content }}</div>
        <div class="pingjiaservebox">
          <div class="servenamepingjia">{{ item.source_data.product_name }}</div>
        </div>
      </div>
    </div>
    <div @click="getMore()" class='orderList_label more' v-if="datalengthX">查看更多</div>
  </div>
</template>

<script>
  import httper from '../../api/http';
  export default {
    data() {
      return {
        evaluatekind: 0,
        tab: [{
          text: "全部",
          value: 1
        }, {
          text: "好评",
          value: 2
        }, {
          text: "中评",
          value: 3
        }, {
          text: "差评",
          value: 4
        }],
        tabIndex: 0,
        score: 5,
        page:1,
        page_size:20,
        datalengthX:false,
        commentList:[],
        commentcount:0,
        entity_id:""
      }
    },
    computed: { //计算属性
      itemClasses() {
        let result = []; // 返回的是一个数组,用来遍历输出星星
        let score = Math.floor(this.score * 2) / 2; // 计算所有星星的数量
        let hasDecimal = score % 1 !== 0; // 非整数星星判断
        let integer = Math.floor(score); // 整数星星判断
        for (let i = 0; i < integer; i++) { // 整数星星使用on
          result.push("on"); // 一个整数星星就push一个CLS_ON到数组
        }
        if (hasDecimal) { // 非整数星星使用half
          result.push("half"); // 类似

        }
        while (result.length < 5) { // 余下的用无星星补全,使用off
          result.push("off");
        }
        return result;
      }
    },
    created() {
      if (this.$route.query.entity_id) {
        this.entity_id = this.$route.query.entity_id
      }else{
        this.entity_id = ''
      }
      this.request("getCommentList", {
        page: this.page,
        page_size: this.page_size,
        entity: "store_service",
        entity_id: this.entity_id
      })
    },
    mounted() {

    },
    methods: {
      //评价星星
      itemClasses1() {
        let that = this
        let list = that.commentList
        // console.log("itemClasses1",list)
        for(let i in list){
          list[i].starlist = []
          // let result = []; // 返回的是一个数组,用来遍历输出星星
          let score = Math.floor(Number(list[i].star) * 2) / 2; // 计算所有星星的数量
          let hasDecimal = score % 1 !== 0; // 非整数星星判断
          let integer = Math.floor(score); // 整数星星判断
          for (let j = 0; j < integer; j++) { // 整数星星使用on
            list[i].starlist.push("on"); // 一个整数星星就push一个CLS_ON到数组
          }
          if (hasDecimal) { // 非整数星星使用half
            list[i].starlist.push("half"); // 类似

          }
          while (list[i].starlist.length < 5) { // 余下的用无星星补全,使用off
            list[i].starlist.push("off");
          }
        }
        that.commentList = list
      },
      //返回上一页
      pageReturn() {
        this.$router.go(-1)
      },
      //返回首页
      pageToIndex() {
        this.$router.push({
          path: "/"
        })
      },
      //改变tab
      changelineIndex(index) {
        console.log("index",index)
        let that = this
        let requestData = {}
        this.tabIndex = index
        this.page = 1
        this.commentList = []
        requestData.page = this.page
        requestData.page_size = this.page_size
        requestData.entity = "store_service"
        requestData.entity_id = this.entity_id
        switch (that.tabIndex) {
          case 0:
            requestData.star = 0
            break
          case 1:
            requestData.star = 5
            break
          case 2:
            requestData.star = 3
            break
          case 3:
            requestData.star = 1
            break
        }
        this.request("getCommentList", requestData)
      },
      //调用接口
      request(type = '', requestData = {}) {
        let that = this
        switch (type) {
          // 获取订单信息列表
          case 'getOrderList':
            httper.post('order/get-list', requestData, res => {
              if (res.code === 0) {
                let lengthX = res.data.length - 20 === 0 //判断列是否20条
                that.datalengthX = lengthX
                // that.list = [...this.list, ...res.data] //数据拼接,
                if (res.data.length > 0) {
                  let list = that.list;
                  for (let i = 0; i < res.data.length; i++) {
                    list.push(res.data[i]);
                  }
                  that.list = list
                }
              } else {
                this.$toast({
                  message: res.message || '系统错误',
                })
              }
            }, true)
            break
          // 获取评价列表
          case "getCommentList":
            httper.post("comment/list", requestData, res => {
              if (res.code == 0) {
                that.commentcount = res.data.count
                let lengthX = res.data.list.length - this.page_size == 0 //判断列是否20条
                that.datalengthX = lengthX
                if (res.data.list.length > 0) {
                  let list = that.commentList;
                  // list.map(v => {
                  //   that.$set(v, 'starlist', false)
                  //   return v
                  // })
                  for (let i = 0; i < res.data.list.length; i++) {
                    list.push(res.data.list[i]);
                  }
                  that.commentList = list
                  this.itemClasses1()
                }
              } else {
                this.$toast({
                  message: res.message || '操作失败',
                });
              }
            }, true);
            break;
        }
      },
      //查看更多
      getMore() {
        let that = this
        if(!that.datalengthX){
          that.$toast({
            message: '没有更多了'
          })
          return
        }
        that.page+=1
        let requestData = {}
        requestData.page = this.page
        requestData.page_size = this.page_size
        requestData.entity = "store_service"
        requestData.entity_id = this.entity_id
        switch (that.tabIndex) {
          case 0:
            requestData.star = 0
            break
          case 1:
            requestData.star = 5
            break
          case 2:
            requestData.star = 3
            break
          case 3:
            requestData.star = 1
            break
        }
        this.request("getCommentList", requestData)
        // that.changelineIndex(that.tabIndex, page, false)

      },
    }
  }
</script>

<style>
  .evaluatepage {
    background-color: #F8F8FA;
  }

  .van-tabs__line {
    background-color: #FD8C00;
    width: 23px !important;
  }

  .evaluatelist {
    margin-top: 20px;
    //background-color: #FFFFFF;
    //padding: 20px;
    //box-sizing: border-box;
  }

  .pingjiabox {
    width: 100%;
    margin-bottom: 16px;
    background-color: #ffffff;
    padding: 20px;
    box-sizing: border-box;
  }

  .pingjiadetailtop {
    width: 100%;
    display: flex;

    justify-content: space-between;
    margin-bottom: 8px;
  }

  .pingjiadetailleft {
    display: flex;
    align-items: center;
  }

  .pingjiaimg {
    width: 38px;
    height: 38px;
    border-radius: 19px;
    margin-right: 13px;
  }

  .pingjiatel {
    font-size: 13px;
    font-weight: bold;
    margin-bottom: 6px;
  }

  .pingjiaxingbox {
    display: flex;
    align-items: center;
  }

  .pingjiatime {
    font-size: 13px;
    color: #666666;
  }

  .labellist {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 10px;
  }

  .labelbox {
    width: 69px;
    height: 23px;
    background: #D9F0FF;
    border-radius: 4px;
    font-size: 13px;
    color: #FD8C00;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 5px;
  }

  .pingjiamessage {
    font-size: 14px;
    margin-bottom: 10px;
  }

  .pingjiaservebox {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .servenamepingjia {
    width: 69px;
    height: 23px;
    background: #F8F8FA;
    border-radius: 10px;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .evaStar {
    float: left;
    padding-top: .34rem;
  }

  .star {
    font-size: 0;
  }

  .star-item {
    display: inline-block;
    background-repeat: no-repeat;
    width: .6rem;
    height: .6rem;
    margin-left: .27rem;
    background-size: 100%;
  }

  .star-item.on {
    background-image: url(../../../static/xingpingjia.png);
  }

  .star-item.half {
    background-image: url(../../../static/xingpingjia.png);
  }

  .star-item.off {
    background-image: url(../../../static/xingnone.png);
  }
  .orderList_label {
    margin: 20px 15px 0;
    display: block;
    text-align: center;
    font-size: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .more {
    padding: 10px 0;
    text-align: center;
    font-size: 15px;
    border: 1px solid #E3E3E3;
    box-shadow: 0 3px 3px #E3E3E3;
    color: orange;
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/offline/evaluateList.vue